import React, { useState } from "react";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TuneIcon from "@mui/icons-material/Tune";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";
import ReglasDetalleTab from "../../facturacion/components/ReglasDetalleTab";
import FacItemsTab from "../../facturacion/components/FacItemsTab";

function TabPanel({ active, children }) {
  return (
    <Box role="tabpanel" hidden={!active} sx={{ display: active ? "block" : "none" }}>
      {children}
    </Box>
  );
}

const FacturacionAdminPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <DashboardLayout>
      <PageHeader
        title="Administracion de facturacion"
        subtitle="Catalogos y reglas usadas para emitir facturas y prefacturas"
        showBack={false}
      />

      <Box sx={{ width: "100%", p: { xs: 1, md: 1.25 } }}>
        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden", borderRadius: 1.25 }}>
          <Tabs
            value={tab}
            onChange={(_, value) => setTab(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 34,
              "& .MuiTab-root": {
                minHeight: 34,
                py: 0.5,
                px: 1.25,
                fontSize: 12,
                textTransform: "none",
              },
            }}
          >
            <Tab icon={<ReceiptLongIcon />} iconPosition="start" label="Items de facturacion" />
            <Tab icon={<TuneIcon />} iconPosition="start" label="Reglas internas" />
          </Tabs>
        </Paper>

        <TabPanel active={tab === 0}>
          <FacItemsTab />
        </TabPanel>
        <TabPanel active={tab === 1}>
          <ReglasDetalleTab />
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
};

export default FacturacionAdminPage;
